/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Strava_DisconnectInputs */

const en_us2_native_release_strava_disconnect = /** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

const pt_br2_native_release_strava_disconnect = /** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconectar`)
};

const pt_pt2_native_release_strava_disconnect = /** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconectar`)
};

/** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */
const es_419_native_release_strava_disconnect = en_us2_native_release_strava_disconnect;

/** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */
const fr_fr2_native_release_strava_disconnect = en_us2_native_release_strava_disconnect;

/** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */
const de_de2_native_release_strava_disconnect = en_us2_native_release_strava_disconnect;

/** @type {(inputs: Native_Release_Strava_DisconnectInputs) => LocalizedString} */
const it_it2_native_release_strava_disconnect = en_us2_native_release_strava_disconnect;

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Native_Release_Strava_DisconnectInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_disconnect = /** @type {((inputs?: Native_Release_Strava_DisconnectInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_DisconnectInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_disconnect(inputs)
	if (locale === "es-419") return es_419_native_release_strava_disconnect(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_disconnect(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_disconnect(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_disconnect(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_disconnect(inputs)
	return en_us2_native_release_strava_disconnect(inputs)
});
export { native_release_strava_disconnect as "native-release.strava_disconnect" }